<template>
    <Card :dis-hover="true">
        <Tabs v-model="saleType"
            :animated="false"
            :capture-focus="true">
            <TabPane label="现售单"
                name="curSale">
                <CurSaleOrderList v-if="saleType ==='curSale'"
                    userType='E'
                    ref="curSaleOrderList" />
            </TabPane>
            <TabPane label="预售单"
                name="preSale">
                <PreSaleOrderList v-if="saleType==='preSale'"
                    userType='E'
                    ref="preSaleOrderList" />
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
import PreSaleOrderList from '../../preSale-management/preSale-order/preSale-order-list';
import CurSaleOrderList from '../../curSale-management/curSale-order/curSale-order-list';

export default {
    name: 'inner-sale-list',
    components: {
        PreSaleOrderList,
        CurSaleOrderList
    },
    data() {
        return {
            saleType: 'curSale'
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>
